import { render, staticRenderFns } from "./DielectricWindowSet.vue?vue&type=template&id=490714d2&scoped=true&lang=pug"
import script from "./DielectricWindowSet.vue?vue&type=script&lang=js"
export * from "./DielectricWindowSet.vue?vue&type=script&lang=js"
import style0 from "./DielectricWindowSet.vue?vue&type=style&index=0&id=490714d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490714d2",
  null
  
)

export default component.exports